<div class="search-bar-holder">
  <div class="search-field" *ngIf="allowSearch">
    <ng-content select="[scaffoldSearchAddition]"></ng-content>
    <div class="search-by-field" *ngIf="searchData?.length > 0 && !hideTermSelect">
        <div style="display: flex; align-items: center; gap:5px">
          <label class="table-header app-label-table">{{'search_by'| translation}}</label>
                  <p-select
          [(ngModel)]="key"
          [options]="searchOptions"
          optionValue="data"
          [placeholder]="'search_by' | translation"
          style="width: 120px"
          
        >
          <ng-template #selectedItem let-selectedOption>
            {{
              selectedOption.translation_key || selectedOption.label
                | translation
                | transformText : "capitalize"
            }}
          </ng-template>

          <ng-template let-op #item>
            {{
              op.translation_key || op.label
                | translation
                | transformText : "capitalize"
            }}
          </ng-template>
        </p-select>
        </div>
      <ng-content select="[scaffoldSearchAddition2]"></ng-content>
    </div>
    <div class="term-field" [ngClass]="{'two-buttons':term}">
      <p-inputgroup>
        <input (keyup.enter)="initSearch()"
               pInputText
               [placeholder]="'search'| translation"
               type="text"
               [(ngModel)]="term"
                />
        <p-inputgroup-addon>
        <p-button
                variant="text"
                *ngIf="term"
                severity="contrast"
                (click)="initSearch(true)"
                type="button"
                [title]="'clear_search'| translation">
                 <i class="fa-thin fa-xmark"></i>
              </p-button>
        <p-button
                variant="text"
                severity="contrast"
                (click)="initSearch()"
                type="button">
                <i class="fa-thin fa-magnifying-glass"></i>
              </p-button>
        </p-inputgroup-addon>
      </p-inputgroup>
    </div>


  </div>
  <ng-content select="[scaffoldSearchAddition3]"></ng-content>
  <div *ngIf="!forceOnlyActive && displayActiveStateFilter" style="display: flex;align-items: center; gap:5px;">
    <label class="table-header app-label-table">{{activePlaceholder}}:</label>
        <p-select
        [(ngModel)]="activeStateFilter"
        [options]="searchOptions3"
        optionValue="value"
        [placeholder]="'search_by' | translation"
        style="width: 120px"
        (onChange)="initSearch()"
        
      >
        <ng-template #selectedItem let-selectedOption>
          {{
            selectedOption.label
              | translation
              | transformText : "capitalize"
          }}
        </ng-template>

        <ng-template let-op #item>
          {{
             op.label
              | translation
              | transformText : "capitalize"
          }}
        </ng-template>
      </p-select>
  </div>
  <ng-content select="[scaffoldSearchAddition4]"></ng-content>
</div>
